import InfoCell from "@/modules/common/components/ui-kit/info-cell";
import useProjectByProperty from "@/modules/property-tracks/hooks/construction/useProjectByProperty.hook";
import { Box, Skeleton, Typography } from "@mui/material";

function formatDate(date?: Date) {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
}

export default function ConstructionProjectDetails({
  projectUid,
}: {
  projectUid: string;
}) {
  const { data, isLoading } = useProjectByProperty(projectUid);
  if (isLoading) {
    return <Skeleton variant="rectangular" width="100%" height={200} />;
  }
  if (data)
    return (
      <Box
        sx={{
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
          width: "100%",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* Details Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={(theme) =>
              theme.nawy.typography.english.variants.body.md.semibold
            }
          >
            Construction Project Details
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            justifyContent: "flex-start",
          }}
        >
          <InfoCell
            title="Planned Execution End Date"
            description={formatDate(data.plannedExecutionEndDate)}
          />
          <InfoCell
            title="Planned Snagging End Date"
            description={formatDate(data.plannedSnaggingEndDate)}
          />
          <InfoCell
            title="Planned Handover End Date"
            description={formatDate(data.plannedHandoverEndDate)}
          />
          <InfoCell
            title="Updated Planned Execution End Date"
            description={formatDate(data.updatedPlannedExecutionEndDate)}
          />
          <InfoCell
            title="Updated Planned Snagging End Date"
            description={formatDate(data.updatedPlannedSnaggingEndDate)}
          />
          <InfoCell
            title="Updated Planned Handover End Date"
            description={formatDate(data.updatedPlannedHandoverEndDate)}
          />
          <InfoCell
            title="Actual Execution End Date"
            description={formatDate(data.actualExecutionEndDate)}
          />
        </Box>
      </Box>
    );
}
